import { takeEvery, put, call, CallEffect, PutEffect } from "redux-saga/effects";

import {
  GET_USER,
  SAVE_AUTH_USER,
  SAVE_AUTH_USER_PWD,
  UPLOAD_AUTH_USER_IMG,
  DELETE_AUTH_USER_IMG,
  REQUEST_PASSWORD_RESET,
  PRE_RESET_PASSWORD,
  RESET_PASSWORD,
  PRE_ACTIVATE_ACCOUNT,
  ACTIVATE_ACCOUNT,
  VERIFY_EMAIL,
} from "./actionTypes";

import {
  getUserOk,
  getUserErr,
  saveUserOk,
  saveUserErr,
  uploadAuthUserImgOk,
  uploadAuthUserImgErr,
  deleteAuthUserImgOk,
  deleteAuthUserImgErr,
  requestPasswordResetOk,
  requestPasswordResetErr,
  preResetPasswordOk,
  preResetPasswordErr,
  resetPasswordOk,
  resetPasswordErr,
  preActivateAccountOk,
  preActivateAccountErr,
  activateAccountOk,
  activateAccountErr,
  verifyEmailOk,
  verifyEmailErr,
} from "./actions";

import {
  getUser,
  saveAuthUser,
  saveAuthUserPwd,
  uploadAuthUserImg,
  deleteAuthUserImg,
  requestPasswordReset,
  preResetPassword,
  resetPassword,
  preActivateAccount,
  activateAccount,
  verifyEmail,
} from "~/helpers/backendHelper";

import { TAction } from "~/types/global";

function* onGetUser({ payload: { id } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(getUser, id);
    yield put(getUserOk(response));
  } catch (error) {
    yield put(getUserErr(error as Error));
  }
}

function* onSaveAuthUser({ payload: { data } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    yield call(saveAuthUser, data);
    yield put(saveUserOk(data));
  } catch (error) {
    yield put(saveUserErr(error as Error));
  }
}

function* onSaveAuthUserPwd({ payload: { data } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    yield call(saveAuthUserPwd, data);
    yield put(saveUserOk(data));
  } catch (error) {
    yield put(saveUserErr(error as Error));
  }
}

function* onUploadAuthUserImg({ payload: { data } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    yield call(uploadAuthUserImg, data);
    yield put(uploadAuthUserImgOk(data));
  } catch (error) {
    yield put(uploadAuthUserImgErr(error as Error));
  }
}

function* onDeleteAuthUserImg(): Generator<CallEffect | PutEffect, void, any> {
  try {
    yield call(deleteAuthUserImg);
    yield put(deleteAuthUserImgOk());
  } catch (error) {
    yield put(deleteAuthUserImgErr(error as Error));
  }
}

function* onRequestPasswordReset({ payload: { data } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(requestPasswordReset, data);
    yield put(requestPasswordResetOk(response));
  } catch (error) {
    yield put(requestPasswordResetErr(error as Error));
  }
}

function* onPreResetPassword({ payload: { token } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(preResetPassword, token);
    yield put(preResetPasswordOk(response));
  } catch (error) {
    yield put(preResetPasswordErr(error as Error));
  }
}

function* onResetPassword({ payload: { token, data } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(resetPassword, token, data);
    yield put(resetPasswordOk(response));
  } catch (error) {
    yield put(resetPasswordErr(error as Error));
  }
}

function* onPreActivateAccount({ payload: { token } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(preActivateAccount, token);
    yield put(preActivateAccountOk(response));
  } catch (error) {
    yield put(preActivateAccountErr(error as Error));
  }
}

function* onActivateAccount({ payload: { token, data } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(activateAccount, token, data);
    yield put(activateAccountOk(response));
  } catch (error) {
    yield put(activateAccountErr(error as Error));
  }
}

function* onVerifyEmail({ payload: { token } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(verifyEmail, token);
    yield put(verifyEmailOk(response));
  } catch (error) {
    yield put(verifyEmailErr(error as Error));
  }
}

function* userSaga() {
  yield takeEvery(GET_USER, onGetUser);
  yield takeEvery(SAVE_AUTH_USER, onSaveAuthUser);
  yield takeEvery(SAVE_AUTH_USER_PWD, onSaveAuthUserPwd);
  yield takeEvery(UPLOAD_AUTH_USER_IMG, onUploadAuthUserImg);
  yield takeEvery(DELETE_AUTH_USER_IMG, onDeleteAuthUserImg);
  yield takeEvery(REQUEST_PASSWORD_RESET, onRequestPasswordReset);
  yield takeEvery(PRE_RESET_PASSWORD, onPreResetPassword);
  yield takeEvery(RESET_PASSWORD, onResetPassword);
  yield takeEvery(PRE_ACTIVATE_ACCOUNT, onPreActivateAccount);
  yield takeEvery(ACTIVATE_ACCOUNT, onActivateAccount);
  yield takeEvery(VERIFY_EMAIL, onVerifyEmail);
}

export default userSaga;
